'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _metaNav = require('./meta-nav.scss');

var _metaNav2 = _interopRequireDefault(_metaNav);

var _i18n = require('../i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _advancedFetch = require('../../advanced-fetch');

var _advancedFetch2 = _interopRequireDefault(_advancedFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_reactI18next.translate.setI18n(_i18n2.default);

var MetaNav = function (_React$Component) {
    _inherits(MetaNav, _React$Component);

    function MetaNav(props) {
        _classCallCheck(this, MetaNav);

        var _this = _possibleConstructorReturn(this, (MetaNav.__proto__ || Object.getPrototypeOf(MetaNav)).call(this, props));

        _this.openLangSelect = _this.openLangSelect.bind(_this);
        _this.changeLanguage = _this.changeLanguage.bind(_this);

        _this.state = {
            isLangSelectOpen: false,
            language: _i18n2.default.language || ''
        };
        return _this;
    }

    _createClass(MetaNav, [{
        key: 'openLangSelect',
        value: function openLangSelect() {
            this.setState(function (prev) {
                return {
                    isLangSelectOpen: !prev.isLangSelectOpen
                };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var t = this.props.t;


            return _react2.default.createElement(
                'div',
                { className: _metaNav2.default["meta-nav"] },
                _react2.default.createElement(
                    'div',
                    { className: _metaNav2.default["lang-select"] },
                    _react2.default.createElement(
                        'div',
                        { onClick: this.openLangSelect },
                        _react2.default.createElement(
                            'span',
                            null,
                            this.state.language.toUpperCase()
                        ),
                        _react2.default.createElement('i', { className: _metaNav2.default["arrow-icon"] })
                    ),
                    this.state.isLangSelectOpen ? _react2.default.createElement(
                        'ul',
                        { className: _metaNav2.default["lang-list"] },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { className: this.state.language === 'de' ? _metaNav2.default["is-active"] : '',
                                    onClick: function onClick(e) {
                                        return _this2.changeLanguage(e, 'de');
                                    },
                                    href: '' },
                                'DE'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { className: this.state.language === 'en' ? _metaNav2.default["is-active"] : '',
                                    onClick: function onClick(e) {
                                        return _this2.changeLanguage(e, 'en');
                                    },
                                    href: '' },
                                'EN'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { className: this.state.language === 'fr' ? _metaNav2.default["is-active"] : '',
                                    onClick: function onClick(e) {
                                        return _this2.changeLanguage(e, 'fr');
                                    },
                                    href: '' },
                                'FR'
                            )
                        )
                    ) : null
                ),
                _react2.default.createElement(
                    'a',
                    { className: _metaNav2.default["meta-link"], href: t('contact-link'), target: '_blank' },
                    t('Contact')
                )
            );
        }

        /**
         *
         * @param e
         * @param lang
         */

    }, {
        key: 'changeLanguage',
        value: function changeLanguage(e, lang) {
            var _this3 = this;

            e.preventDefault();

            fetch('api/change-language', {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ lang: lang })
            }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                _i18n2.default.changeLanguage(lang);

                _this3.setState(function (prev) {
                    prev.language = lang;

                    return prev;
                });

                _this3.openLangSelect();
            });
        }
    }]);

    return MetaNav;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)([])(MetaNav);


//////////////////
// WEBPACK FOOTER
// ./client/components/meta-nav/index.js
// module id = 473
// module chunks = 0